import PriceBreakdownDetails from 'components/park/detail/PriceBreakdownDetails';
import {
  formatServiceFeeToTextWithCurrency,
  getPricesWithCurrency,
} from 'components/park/detail/PriceBreakdownDetailsHelper';
import useParkingPricingInfo from 'hooks/useParkingPricingInfo';
import useSelectedCompanyBenefit from 'hooks/useSelectedCompanyBenefit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParkzoneStore } from 'stores/parkzoneStore';
import { CountryCode, Maybe, PriceEstimate } from 'types/generatedSchemaTypes';

export type NewParkingSessionPriceBreakDownDetailsProps = {
  priceEstimate: Maybe<PriceEstimate> | undefined;
  parkingZoneUid?: string;
  parkingZoneCountryCode?: CountryCode;
};

const NewParkingSessionPriceBreakdownDetails = () => {
  const { t } = useTranslation();
  const newPriceBreakdownDetails = useParkzoneStore(
    (state) => state.newParkingSessionPriceBreakdownValues
  );
  const priceEstimate = newPriceBreakdownDetails?.priceEstimate;
  const parkingZoneUid = newPriceBreakdownDetails?.parkingZoneUid;
  const parkingZoneCountryCode =
    newPriceBreakdownDetails?.parkingZoneCountryCode;
  const { pricingSegments } = useParkingPricingInfo(parkingZoneUid ?? '', true);

  const { totalPrice, serviceFee, parkingFee } = getPricesWithCurrency({
    totalAmount: priceEstimate?.totalAmount,
    serviceFee: priceEstimate?.breakdown?.serviceFee?.amount,
    parkingFee: priceEstimate?.breakdown?.parkingFee?.amount,
    parkingZoneCountryCode,
  });
  const activeSegmentId = useParkzoneStore((state) => state.selectedTariffId);
  const { hasCorporateAccount } = useSelectedCompanyBenefit(parkingZoneUid);

  const {
    percent: serviceFeePercent,
    min: serviceFeeMin,
    max: serviceFeeMax,
    showServiceFeePercentInfo,
  } = formatServiceFeeToTextWithCurrency(
    pricingSegments,
    activeSegmentId ?? '',
    parkingZoneCountryCode,
    hasCorporateAccount
  );

  return (
    <PriceBreakdownDetails
      parkingFee={parkingFee ?? t('price.noPrice')}
      serviceFee={serviceFee ?? t('price.noPrice')}
      totalPrice={totalPrice ?? t('price.noPrice')}
      serviceFeePercent={serviceFeePercent}
      serviceFeeMin={serviceFeeMin}
      serviceFeeMax={serviceFeeMax}
      showServiceFeePercentInfo={showServiceFeePercentInfo}
      hasCorporateAccount={hasCorporateAccount}
    />
  );
};

export default NewParkingSessionPriceBreakdownDetails;
